module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/exclamation.f2642e7a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/exclamation.png
// module id = 2971
// module chunks = 11